import React, { useState, useEffect } from "react";
import SendIcon from "@mui/icons-material/Send";
import { useMutation } from "@tanstack/react-query";
import { createData } from "../../utility/managerApi";

function ChatSendMessage({ selectedContact }) {
  const [message, setMessage] = useState("");
  const [details, setDetails] = useState({
    receiver_id: selectedContact,
    message: message,
  });

  const handleMessage = (e) => {
    setMessage(e.target.value);
    setDetails((prev) => ({ ...prev, message: e.target.value }));
  };

  const messageSend = useMutation({
    mutationFn: () => createData("chats/send", details),
    onSuccess: () => {
      // Handle success (e.g., clear the input)
      setMessage("");
      setDetails((prev) => ({ ...prev, message: "" }));
    },
  });

  const handleSendMessage = (e, details) => {
    e.preventDefault();
    messageSend.mutate(details);
    setMessage("");
  };

  useEffect(() => {
    setDetails((prev) => ({ ...prev, receiver_id: selectedContact }));
  }, [selectedContact]);
  return (
    <form
      onSubmit={(e) => handleSendMessage(e, details)}
      className="p-4 border-t flex justify-center gap-2 items-center border-gray-200"
    >
      <input
        type="text"
        value={message}
        onChange={(e) => handleMessage(e)}
        placeholder="Type a message..."
        className="w-full p-2 border text-black border-gray-300 rounded"
      />
      <button type="submit" aria-label="Send Message">
        <SendIcon className="text-gray-500 cursor-pointer" />
      </button>
    </form>
  );
}

export default ChatSendMessage;
